import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { IMAGES } from "./shared";

const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};

const item = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] } },
};

export const Hero = () => (
    <section
        id="home"
        data-testid="hero-section"
        className="relative flex min-h-svh items-end overflow-hidden bg-night text-ivory lg:min-h-[85vh]"
    >
        <motion.img
            src={IMAGES.hero}
            alt="African and international professionals in a premium global business environment"
            className="absolute inset-0 h-full w-full object-cover object-[58%_center] sm:object-center"
            fetchPriority="high"
            initial={{ scale: 1.06 }}
            animate={{ scale: 1 }}
            transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-night/85 via-night/40 to-night/5" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-night/70 to-transparent" />

        <div className="relative mx-auto w-full max-w-7xl px-6 pb-16 pt-40 sm:pb-20 lg:px-10 lg:pb-20">
            <motion.div initial="hidden" animate="visible" variants={container} className="max-w-2xl">
                <motion.p variants={item} className="flex items-center gap-3">
                    <span className="h-px w-10 bg-champagne" aria-hidden="true" />
                    <span className="text-xs font-semibold uppercase tracking-[0.4em] text-champagne">
                        Afrinexa Global
                    </span>
                </motion.p>
                <motion.p
                    variants={item}
                    className="mt-4 text-[11px] font-medium uppercase tracking-[0.28em] text-ivory/65"
                >
                    International Recruitment • Manpower • Global Mobility
                </motion.p>
                <motion.h1
                    variants={item}
                    className="mt-7 font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
                >
                    Connecting Global Talent
                    <br className="hidden sm:block" /> With Global Opportunity
                </motion.h1>
                <motion.p
                    variants={item}
                    className="mt-6 max-w-xl text-base leading-relaxed text-ivory/80 md:text-lg"
                >
                    Connecting employers with qualified international talent while helping professionals,
                    students and travelers navigate opportunities across borders.
                </motion.p>
                <motion.div variants={item} className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
                    <a
                        href="/recruitment"
                        data-testid="hero-hire-talent-btn"
                        className="inline-flex items-center justify-center gap-2 bg-ivory px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:bg-champagne"
                    >
                        Hire Global Talent
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                    <a
                        href="/jobs"
                        data-testid="hero-find-opportunities-btn"
                        className="inline-flex items-center justify-center gap-2 border border-ivory/40 px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ivory transition-colors duration-300 hover:border-ivory hover:bg-ivory/10"
                    >
                        Find International Opportunities
                    </a>
                </motion.div>
                <motion.div variants={item}>
                    <a
                        href="#global-mobility"
                        data-testid="hero-explore-mobility-link"
                        className="mt-7 inline-flex items-center gap-2 text-sm text-ivory/70 transition-colors hover:text-champagne"
                    >
                        Explore Global Mobility
                        <ArrowUpRight size={15} strokeWidth={1.5} />
                    </a>
                </motion.div>
            </motion.div>
        </div>
    </section>
);
